// Display names for the mushroom groups, shared by the species cards and the
// season backtest so the two panels can never drift apart.
export const groupCopy = {
  bolete: { name: 'Hríbovité spolu', latin: 'Boletaceae, Suillus', habitat: 'duby aj borovice' },
  suchohrib: { name: 'Suchohríby', latin: 'Imleria, Xerocomellus', habitat: 'zmiešaný les' },
  hrib_dubovy: { name: 'Hríb dubový', latin: 'Boletus edulis', habitat: 'dubiny' },
  masliak: { name: 'Masliaky', latin: 'Suillus', habitat: 'borovicové piesky' },
  hrib_smrekovy: { name: 'Smrekáče', latin: 'Boletus edulis / pinophilus', habitat: 'ihličnany' },
  kozak: { name: 'Kozáky a brezáky', latin: 'Leccinum', habitat: 'brezy, duby' },
  bedla: { name: 'Bedle', latin: 'Macrolepiota procera', habitat: 'okraje a lúky' },
  kuriatko: { name: 'Kuriatka', latin: 'Cantharellus', habitat: 'machnaté svahy' },
  rydzik: { name: 'Rýdziky', latin: 'Lactarius', habitat: 'mladé ihličnany' },
  muchotravka: { name: 'Muchotrávky', latin: 'Amanita', habitat: 'indikátor, nezbierať' },
  plavka: { name: 'Plávky', latin: 'Russula', habitat: 'zmiešaný les' },
  cirovka: { name: 'Čírovky', latin: 'Tricholoma', habitat: 'neskorá jeseň' },
  hliva: { name: 'Hlivy', latin: 'Pleurotus', habitat: 'drevo listnáčov' },
  podpnovka: { name: 'Podpňovky', latin: 'Armillaria', habitat: 'pne a korene' },
}

export function label(group) {
  return groupCopy[group] || { name: group, latin: '', habitat: '' }
}
